import { z } from 'zod';

const LenderEventType = {
    APPLICATION_WITHDRAWN: 'APPLICATION_WITHDRAWN',
    APPLICATION_APPROVED: 'APPLICATION_APPROVED',
    APPLICATION_APPROVED_WITH_STIPS: 'APPLICATION_APPROVED_WITH_STIPS',
    APPLICATION_REJECTED: 'APPLICATION_REJECTED',
    STIPULATIONS_UPDATE: 'STIPULATIONS_UPDATE',
    RECEIVED_FUNDS: 'RECEIVED_FUNDS',
    RECEIVED_FOLLOW_UP_FUNDED: 'RECEIVED_FOLLOW_UP_FUNDED',
    RECEIVED_FOLLOW_UP_NOT_FUNDED: 'RECEIVED_FOLLOW_UP_NOT_FUNDED',
    RECEIVED_FOLLOW_UP_OTHER: 'RECEIVED_FOLLOW_UP_OTHER',
};
/**
 * The flow that completed a lender step on a deal. ACTION_ITEM and RETRIGGER are
 * a person; EMAIL_PARSING and API are the lender's integration. Each caller of a
 * step's completion names itself.
 */
const COMPLETION_SOURCE = {
    ACTION_ITEM: 'ACTION_ITEM',
    EMAIL_PARSING: 'EMAIL_PARSING',
    API: 'API',
    RETRIGGER: 'RETRIGGER',
};
const lenderEventOfferTermsShape = {
    approvedAmount: z.coerce.number().positive(),
    apr: z.coerce.number().nonnegative(),
    term: z.coerce.number().int().positive(),
    vsi: z.coerce.number().nonnegative(),
};
/**
 * One set of terms on a lender event, before the handler prices the deal
 * against them. `apr` is a decimal (0.0799 means 7.99%), where a
 * `LenderResponseOffer` holds a percent, and `vsi` is always present. The Admin
 * Portal record-decision and retrigger requests validate their terms with this
 * schema, and each field coerces, so a term posted as a numeric string reads as
 * a number.
 */
const LenderEventOfferSchema = z.object({
    ...lenderEventOfferTermsShape,
    /** Carried from a hand-entered decision; the handler derives the down payment itself. */
    downPayment: z.coerce.number().nonnegative().optional(),
});
/** Every field of an event offer: the term fields plus the hand-entered down payment. */
const LENDER_EVENT_OFFER_FIELDS = LenderEventOfferSchema.keyof().options;
/** Every offer a lender event carries, at least one. The handler prices the first. */
const LenderEventOffersSchema = z.array(LenderEventOfferSchema).nonempty();

export { COMPLETION_SOURCE, LENDER_EVENT_OFFER_FIELDS, LenderEventOfferSchema, LenderEventOffersSchema, LenderEventType };
//# sourceMappingURL=events.js.map
